var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._g(
      { staticClass: "message-wrapper", style: { "z-index": _vm.zIndex } },
      _vm.$listeners
    ),
    [
      _c("div", { staticClass: "message-box" }, [
        _c(
          "div",
          {
            staticClass: "message-main",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "header-box" }, [
              _c("div", { staticClass: "header-l" }, [_vm._v("任务中心")]),
              _c(
                "div",
                {
                  staticClass: "header-r",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onClickClear.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: require("@/icons/svg/t_clear.svg"), alt: "" },
                  }),
                  _c("span", [_vm._v("清除已完成任务")]),
                ]
              ),
            ]),
            _c(
              "ul",
              { staticClass: "menu-box" },
              _vm._l(_vm.configMenu, function (item) {
                return _c(
                  "li",
                  {
                    key: item.id,
                    staticClass: "menu-box-child",
                    class: [
                      _vm.menuKey === item.id ? "menu-box-child-active" : "",
                    ],
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onClickMenu(item)
                      },
                    },
                  },
                  [
                    _vm._v(" " + _vm._s(item.title) + " "),
                    item.num
                      ? _c("span", [_vm._v("(" + _vm._s(item.num) + ")")])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "task-info" },
              [
                _vm._t("tabOne", null, { row: _vm.menuKey }),
                _vm._t("tabTwo", null, { row: _vm.menuKey }),
                _vm._t("tabThree", null, { row: _vm.menuKey }),
                _vm._t("tabFour", null, { row: _vm.menuKey }),
                _vm._t("tabFive", null, { row: _vm.menuKey }),
              ],
              2
            ),
            _c("i", { staticClass: "arrow-icon" }),
          ]
        ),
        _vm.fairingStatus
          ? _c("div", {
              staticClass: "fairing-box",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }